module.exports = __webpack_public_path__ + "img/sankaku_88_red.f430a657.png";